import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/base/deptproperty/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/base/deptproperty/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/base/deptproperty/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/base/deptproperty/submit', params, options);

export const update = (params, options) =>
  request.post('/api/base/deptproperty/submit', params, options);

export const getDeptTree = (tenantId) => {
  return request({
    url: '/api/base/deptproperty/tree',
    method: 'get',
    params: {
      tenantId,
    },
  });
};
